import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { useFormik } from "formik";
import { toast } from 'react-hot-toast';
import * as Yup from "yup";
import axios from 'axios';
import Header from '../../HomePage/Header/Header'
import Footer from '../../HomePage/Footer/Footer'
import HourglassLoader from '../../../Common/HourglassLoader';

import ReCAPTCHA from "react-google-recaptcha";
import FeedbackForm from '../../FeedbackForm/FeedbackForm';

const host = process.env.REACT_APP_API_SERVER;
const siteKey = process.env.REACT_APP_SITE_KEY;

const ForgetPassword = () => {
    const navigate = useNavigate();
    const [captchaToken, setCaptchaToken] = useState(null);
    const [captchaError, setCaptchaError] = useState("");
    const captchaRef = React.useRef(null);

    let [initialValues, setInitialValues] = useState({

        email: "",


    })

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: Yup.object().shape({

            email: Yup.string().required("Email is required.").matches(/^\w+[-\.\w]*@(?!(?:)\.com$)\w+[-\.\w]*?\.\w{2,4}$/, "Enter a valid Email"),



        }),
        onSubmit: async (values, { setSubmitting, resetForm }) => {

            try {
                // if (!captchaToken) {
                //     setCaptchaError("Please complete the CAPTCHA.");
                //     return;
                // }
                setSubmitting(true);

                await axios.post(`${host}/api/web/forget-password`, {
                    ...values,
                    captchaToken
                })
                    .then(function (response) {
                        if (response.status == 200) {
                            setSubmitting(false)

                            toast.success("Otp sent to your mail.");
                            resetForm();

                            navigate('/otp-verification', { state: { email: values.email } })

                        } else {
                            if (captchaRef.current) {
                                captchaRef.current.reset(); // Reset the CAPTCHA
                            }
                            setCaptchaToken(null);
                            setSubmitting(false)

                            toast.error(response.data.message);

                        }

                    })
                    .catch(function (error) {

                        if (captchaRef.current) {
                            captchaRef.current.reset(); // Reset the CAPTCHA
                        }
                        setCaptchaToken(null);
                        setSubmitting(false)
                        toast.error('Error submitting form. Please try again.');

                    })

            }
            catch (error) {
                if (captchaRef.current) {
                    captchaRef.current.reset(); // Reset the CAPTCHA
                }
                setCaptchaToken(null);

                setSubmitting(false)
                toast.error('Error submitting form. Please try again.');

            }

        }
    })

    const handleCaptcha = (token) => {
        setCaptchaToken(token);
        setCaptchaError("");
    };

    return (
        <div>
            <FeedbackForm />
            <Header />
            <div className="login-background">
                {/* <section class="forget-screen-main-secion main-section"> */}
                <div className="login-main-container-two login-main-container">
                    <div className="row login-form-part">
                        <div className="card login-form bg-white">
                            <h3 className="mb-0">Forgot your password</h3>
                            <p>Enter your email to get otp</p>
                            <form onSubmit={formik.handleSubmit} method="POST">
                                <label htmlFor="" className="label">
                                    {" "}
                                    Email Address
                                </label>
                                <input type="email" className='input-form' placeholder="Enter your email" name='email'
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.email}
                                />
                                <div className="help-block with-errors">
                                    {formik.touched.email && formik.errors.email ? (
                                        <div className='text-danger'>{formik.errors.email}</div>
                                    ) : null}
                                </div>
                                {/* <Link to="/login">
                                    <p className="text-end remember-text">Remember your password?</p>
                                </Link> */}

                                <div className='mb-2'>
                                    <ReCAPTCHA
                                        sitekey={siteKey}
                                        onChange={handleCaptcha}
                                        ref={captchaRef} // Attach the ref to the CAPTCHA
                                    />
                                    {captchaError && <div className="text-danger">{captchaError}</div>}
                                </div>

                                <button
                                    type="submit"
                                    disabled={formik.isSubmitting}
                                    className="btn btn-primary reset-btn mb-3"
                                >
                                    {formik.isSubmitting ? <HourglassLoader /> : 'Reset Password'}
                                </button>

                            </form>
                        </div>
                    </div>
                </div>
                {/* </section> */}
            </div>
            <Footer />
        </div>
    )
}

export default ForgetPassword